var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/Filters.ts";
import { ApiCallService } from '@gmini/api-call-service';
import * as t from 'io-ts';
import { AssigneeSource } from './assigneeSource.enum';
import { ApiDomain } from './domain';
export var Filters;
(function (_Filters) {
  var domain = ApiDomain.domain('Filters', {
    name: "domain",
    sid: "eq61yt"
  });
  var IssueDateCodeEnum;
  (function (IssueDateCodeEnum) {
    IssueDateCodeEnum["ALL"] = "ALL";
    IssueDateCodeEnum["LAST_WEEK"] = "LAST_WEEK";
    IssueDateCodeEnum["LAST_2_WEEK"] = "LAST_2_WEEK";
    IssueDateCodeEnum["LAST_MONTH"] = "LAST_MONTH";
    IssueDateCodeEnum["CUSTOM"] = "CUSTOM";
  })(IssueDateCodeEnum || (IssueDateCodeEnum = {}));
  _Filters.IssueDateCodeEnum = IssueDateCodeEnum;
  var IssueLDeadlineCodeEnum;
  (function (IssueLDeadlineCodeEnum) {
    IssueLDeadlineCodeEnum["ALMOST_EXPIRED"] = "ALMOST_EXPIRED";
    IssueLDeadlineCodeEnum["ONLY_EXPIRED"] = "ONLY_EXPIRED";
    IssueLDeadlineCodeEnum["ALL"] = "ALL";
  })(IssueLDeadlineCodeEnum || (IssueLDeadlineCodeEnum = {}));
  _Filters.IssueLDeadlineCodeEnum = IssueLDeadlineCodeEnum;
  var FilterAssigneeSourceType = t.union([t.literal(AssigneeSource.USER), t.literal(AssigneeSource.ROLE), t.literal(AssigneeSource.COMPANY)]);
  var FilterAssigneeType = t.type({
    source: FilterAssigneeSourceType,
    assigneeId: t.string
  });
  var IssueDateCodeType = t.union([t.literal(IssueDateCodeEnum.ALL), t.literal(IssueDateCodeEnum.LAST_WEEK), t.literal(IssueDateCodeEnum.LAST_2_WEEK), t.literal(IssueDateCodeEnum.LAST_MONTH), t.literal(IssueDateCodeEnum.CUSTOM)]);
  var IssueLDeadlineCodeType = t.union([t.literal(IssueLDeadlineCodeEnum.ALL), t.literal(IssueLDeadlineCodeEnum.ONLY_EXPIRED), t.literal(IssueLDeadlineCodeEnum.ALMOST_EXPIRED)]);
  var FilterType = _Filters.FilterType = t.intersection([t.type({
    id: t.number,
    name: t.string,
    authorId: t.string
  }), t.partial({
    publicId: t.union([t.string, t["null"]]),
    assignees: t.array(FilterAssigneeType),
    statuses: t.array(t.string),
    Ids: t.array(t.string),
    createdDateCode: t.union([IssueDateCodeType, t["null"]]),
    updatedDateCode: t.union([IssueDateCodeType, t["null"]]),
    deadlineCode: t.union([IssueLDeadlineCodeType, t["null"]]),
    attributeValueIds: t.union([t.array(t.string), t["null"]])
  })]);
  var fetchSavedFilters = _Filters.fetchSavedFilters = ApiCallService.create({
    name: 'fetchSavedFilters',
    parentDomain: domain,
    result: t.array(FilterType),
    getKey: function getKey() {
      return '0';
    }
  });
  var fetchSavedFilter = _Filters.fetchSavedFilter = ApiCallService.create({
    name: 'fetchSavedFilter',
    parentDomain: domain,
    result: FilterType,
    getKey: ['id']
  });
  var saveFilter = _Filters.saveFilter = ApiCallService.create({
    name: 'saveFilter',
    parentDomain: domain,
    result: FilterType,
    getKey: ['name', 'authorId']
  });
  var deleteFilter = _Filters.deleteFilter = ApiCallService.create({
    name: 'deleteFilter',
    parentDomain: domain,
    result: FilterType,
    getKey: ['id']
  });
  var updateFilter = _Filters.updateFilter = ApiCallService.create({
    name: 'updateFilter',
    parentDomain: domain,
    result: FilterType,
    getKey: ['id']
  });
})(Filters || (Filters = {}));